import {AbstractService} from 'services/AbstractService';

const ACCOUNT_CONNECTIONS_URL = '/api/connections';
const CONNECTION_DETAILS_URL = '/api/connections/{0}';
const PENDING_CONNECTION_URL = '/api/connections/pending/{0}';
const CREATE_PENDING_MCC_URL = '/api/connections/{0}/childpending';
const MAKE_CONNECTION_FROM_PENDING_URL = '/api/connections/pending/{0}/createconnections';
const CREATE_NEW_PENDING_CONNECTION_URL = '/api/channels/{0}/pendingconnection';
const ADD_SUBCONNECTION_URL = '/api/channels/{0}/connections';

export class ConnectionsService extends AbstractService {

  getFormattedName (connection) {
    return `#${connection.id} ${connection.descriptive_name} (${connection.customer_xid})`;
  }

  getAccountConnections (accountId, inherited = false) {
    return this.client.get(
      ACCOUNT_CONNECTIONS_URL,
      {inherited},
      {accountId}
    );
  }

  get (accountId, connectionId, inherited = false, axiosParams = {}) {
    if (Object.keys(axiosParams).length) {
      return this.client.get(
        CONNECTION_DETAILS_URL.format(connectionId),
        {inherited},
        {accountId},
        axiosParams
      );
    }

    return this.client.get(
      CONNECTION_DETAILS_URL.format(connectionId),
      {inherited},
      {accountId}
    );
  }

  async getPending (accountId, pendingConnectionId) {
    return (await this.client.get(
      PENDING_CONNECTION_URL.format(pendingConnectionId),
      {},
      {accountId}
    )).data;
  }

  async addMccForPending (accountId, pendingConnectionId, {clientXid}) {
    return (await this.client.post(
      PENDING_CONNECTION_URL.format(pendingConnectionId),
      {client_xid: clientXid},
      {accountId}
    )).data.data;
  }

  async addPendingMccForConnection (accountId, connectionId, {clientXid}) {
    return (await this.client.post(
      CREATE_PENDING_MCC_URL.format(connectionId),
      {client_xid: clientXid},
      {accountId}
    )).data.data;
  }

  async updatePendingConnection (_accountId, pendingConnectionId, {accountId, params}) {
    return (await this.client.put(
      PENDING_CONNECTION_URL.format(pendingConnectionId),
      {
        account_id: accountId,
        params
      },
      _accountId
    )).data;
  }

  async makeConnectionTreeFromPending (accountId, pendingConnectionId) {
    return (await this.client.post(
      MAKE_CONNECTION_FROM_PENDING_URL.format(pendingConnectionId),
      {},
      {accountId}
    )).data.data;
  }

  async createNewPendingConnection (accountId, channelId, {connectionType, ...restPayload}) {
    if (!connectionType) {
      return null;
    }

    return (await this.client.post(
      CREATE_NEW_PENDING_CONNECTION_URL.format(channelId),
      {
        connection_type: connectionType,
        ...restPayload
      },
      {accountId}
    )).data.data;
  }

  async createConnection (accountId, channelId, {
    connectionType, login, password,
    application_key, private_key, token,
    secret_key, access_id, client_id, api_key, currency_id, descriptive_name, spreadsheet_url,
    related_customer_xid
  }) {
    return (await this.client.post(
      ADD_SUBCONNECTION_URL.format(channelId),
      {
        channel_id: channelId,
        connection_type: connectionType,
        login,
        password,
        application_key,
        private_key,
        token,
        secret_key,
        access_id,
        client_id,
        api_key,
        currency_id,
        descriptive_name,
        spreadsheet_url,
        related_customer_xid
      },
      {accountId}
    )).data;
  }

  createChildConnection (accountId, channelId, {connectionType, login, parentConnectionId}) {
    return this.client.post(ADD_SUBCONNECTION_URL.format(channelId), {
      channel_id: channelId,
      connection_type: connectionType,
      login,
      parent_connection_id: parentConnectionId
    }, {accountId});
  }
}
